interface BasketCountProps {
  count: number;
  className?: string;
}

export default function BasketCount({ count, className = '' }: BasketCountProps) {
  if (count === 0) return null;
  return (
    <span className={`bg-accent text-white rounded-full px-2 py-1 text-xs font-bold ${className}`}>
      {count}
    </span>
  );
}
